//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "help",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
    };
  },
  methods: {
    //返回上一页
    onClickLeft(){
      try {
        this.$router.back()
        let isIos = /iPad|iPhone|iPod|ios/.test(navigator.userAgent) && !window.MSStream;
        if(isIos){
          window.webkit.messageHandlers.onExitPage.postMessage({"page":"about"});
        }else{
          window.AndroidInterface.onExitPage()
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  mounted() {

  },
};



// WEBPACK FOOTER //
// ./src/pages/me/setting/policy.vue